import links from './enhancements/links';
import tracking from './enhancements/tracking';
import scroller from './directives/action/scroller';
import toggler from './directives/action/toggler';
import selector from './directives/action/selector';
import tracker from './directives/action/tracker';
import autosize from './directives/form/autosize';
import floatLabel from './directives/form/float-label';
import validator from './directives/form/validator';
import recaptcha from './directives/form/recaptcha';
import lightbox from './directives/media/lightbox';
import playOnHover from './directives/media/play-on-hover';
import swiper from './directives/media/swiper';
import map from './directives/media/map';
import fade from './directives/scroll/fade';
import lazyLoad from './directives/scroll/lazy-load';
import parallax from './directives/scroll/parallax';
import reveal from './directives/scroll/reveal';
import sticky from './directives/scroll/sticky';
import inspectScroll from './directives/inspect/inspect-scroll';

export default function init(context=document.body) {
    links(context);
    tracking(context);
    scroller(context);
    toggler(context);
    selector(context);
    tracker(context);
    autosize(context);
    floatLabel(context);
    validator(context);
    recaptcha(context);
    lightbox(context);
    playOnHover(context);
    swiper(context);
    map(context);
    fade(context);
    lazyLoad(context);
    parallax(context);
    reveal(context);
    sticky(context);
    inspectScroll(context);
}



// WEBPACK FOOTER //
// ./source/scripts/init.js